import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Crown, Download, Sparkles as SparklesIcon } from "lucide-react";
import Sparkles from "../components/Sparkles";
import { downloadUrl, fileUrl, getShare } from "../lib/api";

const TE = { fontFamily: "'Tiro Telugu','Noto Serif Telugu','Yatra One','Eczar',serif" };

export default function SharePage() {
  const { id: routeId } = useParams();
  // Static-host safe: links use "/?share=<id>" so the root page (which always
  // exists) can render shares even without SPA fallback rules on the server.
  const queryId = typeof window !== "undefined"
    ? new URLSearchParams(window.location.search).get("share")
    : null;
  const id = routeId || queryId;
  const [share, setShare] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!id) { setError(true); return; }
    getShare(id).then(setShare).catch(() => setError(true));
  }, [id]);

  return (
    <div className="min-h-screen bg-plum-deep text-blush relative overflow-x-hidden" data-testid="share-page">
      <div
        className="fixed inset-0 pointer-events-none"
        style={{ background: "radial-gradient(ellipse at 50% 0%, rgba(212,175,55,0.18), transparent 55%), linear-gradient(180deg, #2a0d2e 0%, #1a0620 100%)" }}
      />
      <Sparkles count={40} />

      <div className="relative z-10 max-w-3xl mx-auto px-4 py-10 text-center">
        <Crown className="mx-auto text-[#FCF6BA] mb-3" size={40} />
        <p className="font-script gold-text drop-shadow-2xl" style={{ ...TE, fontSize: "clamp(30px, 6vw, 52px)" }}>
          అనఘ రాజ్యం జ్ఞాపకాలు
        </p>
        <p className="label-eyebrow text-blush/80 mt-1" style={TE}>
          Anagha's First Birthday · Memories
        </p>

        {error && (
          <div className="mt-16" data-testid="share-not-found">
            <SparklesIcon size={36} className="mx-auto text-[#FCF6BA] mb-3" />
            <p className="font-display text-xl" style={TE}>ఈ లింక్ కనబడలేదు</p>
            <p className="text-blush/70 text-sm mt-1">This share link was not found or has been removed.</p>
          </div>
        )}

        {share && (
          <>
            <div className="mt-6 inline-block glass-deep rounded-full px-6 py-2.5">
              <p className="font-display text-lg" style={TE} data-testid="share-guest-name">
                ✨ {share.guest_name} ✨
              </p>
            </div>
            <p className="text-blush/75 text-sm mt-3" style={TE}>
              మీ ఫోటోలు క్రింద ఉన్నాయి — డౌన్‌లోడ్ బటన్ నొక్కి దాచుకోండి
            </p>

            <div className="mt-8 space-y-8" data-testid="share-photos">
              {share.photos.map((p, i) => (
                <div key={p} className="relative">
                  <div
                    className="rounded-3xl overflow-hidden mx-auto"
                    style={{
                      border: "6px solid",
                      borderImage: "linear-gradient(135deg, #FCF6BA, #D4AF37 40%, #8B6A1A) 1",
                      boxShadow: "0 24px 60px rgba(0,0,0,0.55)",
                      background: "#000",
                    }}
                  >
                    <img
                      src={fileUrl(p)}
                      alt={`${share.guest_name} ${i + 1}`}
                      className="w-full h-auto block"
                      loading="lazy"
                    />
                  </div>
                  <a
                    href={downloadUrl(p, `${share.guest_name}-anagha-memory-${i + 1}`)}
                    className="btn-royal inline-flex items-center gap-2 text-sm py-2.5 px-6 mt-4"
                    data-testid={`share-download-${i}`}
                  >
                    <Download size={15} /> డౌన్‌లోడ్ / Download
                  </a>
                </div>
              ))}
            </div>

            <p className="font-script gold-text mt-12" style={{ ...TE, fontSize: "clamp(20px, 4vw, 30px)" }}>
              ప్రేమతో, అనఘ 💛
            </p>
          </>
        )}
      </div>
    </div>
  );
}
